import { useMutation, useQueryClient } from 'react-query';
import { resendInvitation } from 'resources/user/workflows';
import uiNotifications from 'services/uiNotification.service';
import { getFullName } from 'resources/user/user.helpers';


export default function useResendInvitation() {
  const queryClient = useQueryClient();

  return useMutation(
    (requestData) => resendInvitation(requestData),
    {
      onSuccess: (response) => {
        if (!response || response.isBadRequest || !response.updatedUser) {
          return;
        }

        queryClient.invalidateQueries('user.invitedUser');
        queryClient.invalidateQueries(['users.userById', response.updatedUser.id]);
        queryClient.invalidateQueries(['users.getRealtorClients', response.updatedUser.id]);
        queryClient.invalidateQueries(['deal.getByClientId', response.updatedUser.id]);

        if (!response.acceptInviteLink) {
          uiNotifications.showSuccess(`Re-sent invitation to ${getFullName(response.updatedUser)}.`);
        }
      },
      onError: (error) => {
        uiNotifications.showExtractedError(error, 'Re-sending invitation failed. ', { duration: 10 });
      },
    },
  );
}
